import { render } from "./UroprimePage.vue?vue&type=template&id=52757f80"
import script from "./UroprimePage.vue?vue&type=script&lang=js"
export * from "./UroprimePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__